import { useTrans } from "@/i18n"
import { CardBody, CardWrapper } from "@/components/Card"
import { Heading } from "@/components/Typography"

import { useCurrentUserMangoPayStatus, useCurrentUserKyc } from "@/context/user"
import { RiskKycStateChoices } from "@/api/graphql"

import { ScaEnrollmentStep } from "./ScaEnrollmentStep"
import { KycVerificationStep } from "./KycVerificationStep"

export const MangoPaySCAEnrollBanner = () => {
	const t = useTrans("investor")

	const scaEnrolled = useCurrentUserMangoPayStatus()
	const userKyc = useCurrentUserKyc()
	const kycVerified =
		userKyc?.state === RiskKycStateChoices.VerificationSuccess

	let kycStatus: "upcoming" | "complete" | "current"
	if (!scaEnrolled) {
		kycStatus = "upcoming"
	} else if (kycVerified) {
		kycStatus = "complete"
	} else {
		kycStatus = "current"
	}

	return (
		<CardWrapper className="relative mb-4">
			<CardBody>
				<Heading as="h2" styleAs="h5" className="mb-3 sm:truncate">
					{t("investor:identity.copy.mangopay.title")}
				</Heading>

				<ol className="mb-6 space-y-6">
					<ScaEnrollmentStep isComplete={scaEnrolled} />
					<KycVerificationStep status={kycStatus} />
				</ol>
			</CardBody>
		</CardWrapper>
	)
}
